// @ts-check
import React, { Component } from 'react';
import {
  Field,
  Fields,
  reduxForm as originalReduxForm,
  SubmissionError,
  formValueSelector,
  FieldArray,
  change,
  reset,
} from 'redux-form';

import reduxFormWithDebugging from '../reduxFormWithDebugging';

// NB: There's a fix for that is in the master branch of redux-form, so if you come upon this reading, this line may no longer be required.
//     This line was put in during an upgrade to redux-form v6.8.0
const reduxForm = (initialConfig) => originalReduxForm(initialConfig || {});

const FormContent = ({ content, ...formProps }) => content(formProps);

class Form extends Component {
  constructor(props, context) {
    super(props, context);
    // This is a component which sets context and then renders FormRenderer with
    // formProps as well as any props you choose to give it when you use it.
    this.reduxFormComponent = reduxForm(props)(FormContent);
  }

  render() {
    return React.createElement(this.reduxFormComponent, {
      content: this.props.content,
    });
  }
}

export { Form };

export function inlineReduxForm(props, contentFunction) {
  return <Form {...props} content={contentFunction} />;
}

// FieldWithRender is like Field, except it also accepts a prop
// called `render`, which is a function returning JSX/elements
const InlineRender = (props) => {
  let { render, ...rest } = props;
  render = props.children || render;
  return render({ ...rest });
};

const FieldWithRender = (props) => (
  <Field component={InlineRender} {...props} />
);

const WatchFieldValue = (props) => (
  <FieldWithRender
    {...props}
    render={(fieldProps) => props.render({ value: fieldProps.input.value })}
  />
);

/**
 *
 * @param {SubmissionError} error
 */
export function getErrorMessage(error) {
  if (
    error &&
    error.errors &&
    error.errors._error &&
    error.errors._error.length > 0
  ) {
    return error.errors._error[0];
  } else {
    return 'Could not complete appointment';
  }
}

// Use real v6:
export {
  WatchFieldValue,
  InlineRender,
  FieldArray,
  Fields,
  FieldWithRender as Field, // Returning FieldWithRender, since it is backward compatible with Field
  reduxFormWithDebugging,
  reduxForm,
  SubmissionError,
  formValueSelector,
  change,
  reset,
};
